import React, { useEffect } from 'react'
import { PropsWithChildren } from 'react'
import { ActivationObjectContext } from '../constants'
import { ActivationObjectProviderProps } from '../types'
import { useSnackbar } from 'notistack'
import { useHistory } from 'react-router'

const ActivationObjectProviderView: React.FC<PropsWithChildren<ActivationObjectProviderProps>> = ({
    children,
    contextValue,
    error,
    notFound,
}) => {
    const { enqueueSnackbar } = useSnackbar()
    const history = useHistory()

    useEffect(() => {
        if (error) enqueueSnackbar(error, { variant: 'error' })
    })

    // redirect to Welcome page, if activation object is not found
    useEffect(() => {
        if (notFound) history.replace('/')
        if (contextValue.data) {
            switch (contextValue.data.wizardStep) {
                case 'Finish':
                    history.push('/thanks')
                    break
                case 'Redirect':
                case 'ObjectConnectToDifferentPCO':
                    history.push('/redirect')
                    break
                default:
                    history.replace('/wizard')
                    break
            }
        }
    }, [contextValue.data, history, notFound])

    return <ActivationObjectContext.Provider value={contextValue}>{children}</ActivationObjectContext.Provider>
}
export default ActivationObjectProviderView
